<template>
	<el-dialog title="新增保养" v-model="isAdd" width="60%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<!-- <p class="platTitle">基础信息</p> -->
			<div class="info-input-container">
				<div class="flex flex-y-start flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>车牌号码</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="vempVehId" placeholder="请选择">
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehNo"
									:value="item.vehId">
								</el-option>
							</el-select>
							<!-- <el-select v-model="vempVehId" filterable placeholder="请选择">
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehHeadNo"
									:value="item.vehicleId">
									<span style="float: left">{{ item.vehHeadNo }}</span>
									<span style="
															          float: right;
															          color: var(--el-text-color-secondary);
															          font-size: 13px;
															        ">
										{{ item.vehAffOrgName }}
									</span>
								</el-option>
							</el-select> -->
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">

					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养时日期</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="vempLastDate" type="datetime" :clearable="false"
								placeholder="请选择保养日期" @change="getvempLastDate">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养时里程</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vempLastMiles" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养里程周期</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vempMilesInterval" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>提前提醒里程</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vempMilesAdvance" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养时间周期</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vempDateInterval" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>月
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>提前提醒时间</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vempDateAdvance" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>天
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注</span>
						</div>
						<el-input v-model="vempRemark" class="platItemRigth" placeholder="请输入" />
					</div>
				</div>
			</div>


			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<div class="confirm_btn" v-on:click="submit()">确定</div>
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>

		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		parseTime,
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	// import Address from "./address";
	export default defineComponent({
		components: {
			// Address
		},
		name: "Add",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};

			onMounted(() => {
				nextTick(() => {
					getVehHeadList(); //获取车辆
				});
			});
			const data = reactive({
				isAdd: false,
				vehHeadList: [],

				vempVehId: "",
				vempLastDate: "",
				vempLastMiles: "",
				vempDateInterval: "",
				vempDateAdvance: "",
				vempMilesInterval: "",
				vempMilesAdvance: "",
				vempRemark: "",

			});
			//重置数据
			const init = () => {
				data.isAdd = true;
				data.vempVehId = "";
				data.vempLastDate = "";
				data.vempLastMiles = "";
				data.vempDateInterval = "";
				data.vempDateAdvance = "";
				data.vempMilesInterval = "";
				data.vempMilesAdvance = "";
				data.vempRemark = "";

			};

			const dialogClosedHandle = () => {
				data.isAdd = false;
			};
			const closeModal = () => {
				data.isAdd = false;
			};
			const submit = async () => {
				if (data.vempVehId == "") {
					proxy.$message.error("请选择车辆");
					return;
				}
				if (data.vempLastDate == "") {
					proxy.$message.error("请填写保养时日期");
					return;
				}
				if (data.vempLastMiles == "") {
					proxy.$message.error("请填写保养时里程");
					return;
				}
				if (data.vempDateInterval == "") {
					proxy.$message.error("请填写保养时间周期");
					return;
				}
				if (data.vempDateAdvance == "") {
					proxy.$message.error("请填写提前提醒时间");
					return;
				}
				if (data.vempMilesInterval == "") {
					proxy.$message.error("请填写保养里程周期");
					return;
				}
				if (data.vempMilesAdvance == "") {
					proxy.$message.error("请填写提前提醒里程");
					return;
				}

				let params = {
					vempVehId: data.vempVehId,
					vempLastDate: data.vempLastDate,
					vempLastMiles: data.vempLastMiles,
					vempDateInterval: data.vempDateInterval,
					vempDateAdvance: data.vempDateAdvance,
					vempMilesInterval: data.vempMilesInterval,
					vempMilesAdvance: data.vempMilesAdvance,
					vempRemark: data.vempRemark,
				}

				const r = await proxy.$http.post(apiObj.vehMaintenanceProdadd, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isAdd = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};

			//选择运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};

			//选择牵引车辆
			const getVehHeadList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10",
				};
				const r = await proxy.$http.get(apiObj.vehGetHeadList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.vehList;
				}
			};

			//选择挂车车辆
			// const getVehTailList = async () => {
			// 	let params = {
			// 		searchWord: "",
			// 		offset: "0",
			// 		limit: "10",
			// 	};
			// 	const r = await proxy.$http.get(apiObj.vehGetTailList, params);
			// 	console.log(r);
			// 	if (r.code === 0 || r.respCode === '0000') {
			// 		data.vehTailList = r.vehList;
			// 	}
			// };


			const getvempLastDate = (ev) => {
				data.vempLastDate = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.vempLastDate);
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getvempLastDate,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}



	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 90px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.input_box {
		margin-left: 20px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 77%;
		height: 35px;
		padding-left: 0px;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #606266;
		cursor: pointer;
		width: 60px;
		text-align: right;
	}
</style>